export default __webpack_public_path__ + "static/media/forestview.70f06aee.jpg";